<template>
  <canvas id="preview-audio" ref="audioAnalysis"></canvas>
</template>

<script>
  /**
  * Component that renders an animated visualisation of the audio media stream returned from the Video Preview Component
  */
  export default {
    name: 'CanvasAudioPreview',
    data () {
      return {
        audioContext: new (window.AudioContext || window.webkitAudioContext)(),
        requestAnimationFrame: null,
        maxAudioLevel: 0
      }
    },

    props: {
      /** MediaStream object from the `<audio>` element rendered in the VideoPreview Component **/
      'audioMediaStream': {
        'default': null
      }
    },

    methods: {

      /**  Creates a canvas context and draws the visualisation to the canvas
      * @param {MediaStream} mediaStream
      * @public
      **/
      drawAudioLevels (mediaStream) {
        const cnvs = this.$refs.audioAnalysis
        const WIDTH = cnvs.width
        const HEIGHT = cnvs.height
        const canvasCtx = cnvs.getContext('2d')
        const audioContext = this.audioContext
        const analyser = audioContext.createAnalyser()
        const microphone = audioContext.createMediaStreamSource(mediaStream)
        microphone.connect(analyser)
        analyser.fftSize = 256
        const bufferLength = analyser.frequencyBinCount
        const dataArray = new Uint8Array(bufferLength)

        canvasCtx.clearRect(0, 0, WIDTH, HEIGHT)
        const draw = () => {
          this.requestAnimationFrame = requestAnimationFrame(draw)
          analyser.getByteFrequencyData(dataArray)

          canvasCtx.fillStyle = 'rgb(255, 255, 255)'
          canvasCtx.fillRect(0, 0, WIDTH, HEIGHT)

          this.setMaxAudioLevel(dataArray)

          let barWidth = (WIDTH / bufferLength) * 2.5
          let barHeight
          let x = 0
          for (let i = 0; i < bufferLength; i++) {
            barHeight = dataArray[i]
            canvasCtx.fillStyle = 'rgb(91,192,222)'
            canvasCtx.fillRect(x, ((HEIGHT - barHeight)), barWidth, (barHeight))
            x += barWidth + 1
          }
        }
        return draw()
      },

      /**  Checks to see does the MediaStream have the correct track and exectutes the `drawAudioLevels()` mehtod if it does
      * @public
      **/
      showAudioLevels () {
        if (this.audioMediaStream && this.audioMediaStream.getAudioTracks().length) {
          return this.drawAudioLevels(this.audioMediaStream)
        }
      },

      setMaxAudioLevel (dataArray) {
        const localMax = Math.max(Math.max.apply(null, dataArray), 0)
        this.maxAudioLevel = Math.max(localMax, this.maxAudioLevel)
      }
    },

    watch: {
      audioMediaStream (newVal, oldVal) {
        cancelAnimationFrame(this.requestAnimationFrame)
        this.maxAudioLevel = 0
        this.showAudioLevels()
      },

      maxAudioLevel () {
        this.$emit('maxAudioLevel', this.maxAudioLevel)
      }

    },

    mounted () {
      this.showAudioLevels()
    },

    destroyed () {
      cancelAnimationFrame(this.requestAnimationFrame)
      this.audioContext.close()
    }
  }

</script>

<style scoped>
canvas#preview-audio {
    display: block;
    margin: auto;
    height: 25px;
    width: 100%;
    border: 1px solid #CCC;
    margin-bottom: 20px;
    border-radius: 4px;
}
</style>
